<div class='row m-0 client-list-layout'>
  <div class='col-md-7 col-sm-12 left-panel table-container'
       [ngClass]="{'popup-hide': isDisplay}">
    <nb-card>
      <nb-card-body>

        <!--        BEGIN FILTER-->
<!--        <div class='row'>-->
<!--          <div class='col-lg-12 col-xs-12 mt-2'>-->
<!--            <nb-form-field>-->
<!--              <input nbInput fullWidth fieldSize='small' placeholder='Address' [(ngModel)]='addressQuery'-->
<!--                     (keydown.enter)='onSearch()'>-->
<!--              <span nbSuffix *ngIf='stringUtils.isNotEmpty(searchRequest.addressQuery)' (click)='clearQuery()'>-->
<!--            <i class='fa fa-times-circle custom-icon'></i></span>-->
<!--              <span nbSuffix class='ml-2 mr-4' *ngIf='stringUtils.isNotEmpty(addressQuery)'-->
<!--                    (click)='onSearch()'>-->
<!--            <i class='fa fa-search custom-icon'></i></span>-->
<!--            </nb-form-field>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class='row mt-2'>-->
<!--          <div class='col-sm-12 col-lg-4 mb-2'>-->
<!--            <select class='select-custom' [(ngModel)]='classificationOption' size='tiny'-->
<!--                    (change)='onSelectClassificationOption()'>-->
<!--              <option [value]='undefined'>All</option>-->
<!--              <option *ngFor='let option of clientRateOptions' [value]='option'>-->
<!--                {{ option }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
<!--          <div class='col-lg-8 col-sm-12 p-0'>-->
<!--            <div class='row m-0'>-->
<!--              <div class='col-2'>-->
<!--                <select class='select-custom' [(ngModel)]='searchRequest.type' size='tiny'-->
<!--                        (change)='onSelectSpec("type")'>-->
<!--                  <option [value]='undefined'><span>Type</span></option>-->
<!--                  <option *ngFor='let type of propertyType | keyvalue:keepOrder'-->
<!--                          [value]='type.key'>{{ type.value }}-->
<!--                  </option>-->
<!--                </select>-->
<!--              </div>-->
<!--              <div class='col-2'>-->
<!--                <select class='select-custom' [(ngModel)]='searchRequest.bed' size='tiny'-->
<!--                        (change)='onSelectSpec("bed")'>-->
<!--                  <option [value]='undefined'><span>Bed</span></option>-->
<!--                  <option *ngFor='let item of bedValues' [value]='item'>{{ item }}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--              <div class='col-2'>-->
<!--                <select class='select-custom' [(ngModel)]='searchRequest.bath' size='tiny'-->
<!--                        (change)='onSelectSpec("bath")'>-->
<!--                  <option [value]='undefined'><span>Bath</span></option>-->
<!--                  <option *ngFor='let item of bedValues' [value]='item'>{{ item }}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--              <div class='col-2'>-->
<!--                <select class='select-custom' [(ngModel)]='searchRequest.car' size='tiny'-->
<!--                        (change)='onSelectSpec("car")'>-->
<!--                  <option [value]='undefined'><span>Car</span></option>-->
<!--                  <option *ngFor='let item of bedValues' [value]='item'>{{ item }}</option>-->
<!--                </select>-->
<!--              </div>-->
<!--              <div class='col-2'>-->
<!--                <input nbInput fullWidth type="number" fieldSize='tiny' placeholder="From Land"-->
<!--                       [(ngModel)]="searchRequest.fromLand">-->
<!--              </div>-->
<!--              <div class='col-2'>-->
<!--                <input nbInput fullWidth type="number" fieldSize='tiny' placeholder="To Land"-->
<!--                       [(ngModel)]="searchRequest.toLand">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class='row mt-2'>
          <div class='col-12 px-0'>
            <div class='client-list-action-row'>
              <button nbButton size='tiny' class='custom-client-list-button-color client-list-action-button'
                      [ngClass]="{'active-checklist-button': activeChecklist === 'OTM'}"
                      (click)='selectDailyChecklist("OTM")'>OTM
              </button>
              <button nbButton size='tiny' class='custom-client-list-button-color client-list-action-button'
                      [ngClass]="{'active-checklist-button': activeChecklist === 'SRV2'}"
                      (click)='selectDailyChecklist("SRV2")'>SRV
              </button>
              <button class='custom-client-list-button-color client-list-action-button' nbButton size='tiny'
                      [ngClass]="{'active-checklist-button': activeChecklist === 'WITHDRAWN'}"
                      (click)='selectDailyChecklist("WITHDRAWN")'>WITHDRAWN
              </button>
              <button class='custom-client-list-button-color client-list-action-button' nbButton size='tiny'
                      [ngClass]="{'active-checklist-button': activeChecklist === 'UPCOMING_EXPIRE'}"
                      (click)='selectDailyChecklist("UPCOMING_EXPIRE")'>UPCOMING EXPIRE
              </button>
              <button nbButton size='tiny'
                      class='custom-client-list-button-color client-list-action-button'
                      nbTooltip='Trigger Search'
                      (click)='onSearchButtonClick()'>
                Search
              </button>
            </div>
          </div>
        </div>
        <div class='row mt-3' *ngIf='showAdvance'>
          <div class='col-12 mb-2 filter-cell'>
            <select size='tiny'
                    [(ngModel)]='streetId'
                    [disabled]='!districtId'
                    class='full-width select-custom'
                    (change)='onStreetSelectChange($event)'
            >
              <option [value]='undefined'>All streets</option>
              <option *ngFor='let key of filteredStreets'
                      [ngClass]="key.status === 'DEACTIVE' ? 'deactive-status' : ''"
                      [value]='key.streetId'
              >{{ key.name }}
              </option>
            </select>
          </div>
          <div class='col-6 mb-2 filter-cell'>
            <select size='tiny'
                    [(ngModel)]='districtId'
                    [disabled]='!filterByPostcode'
                    class='full-width select-custom'
                    (change)='onSuburbSelectChange($event)'
            >
              <option [value]='undefined'>All suburbs</option>
              <option *ngFor='let key of filteredDistricts'
                      [ngClass]="key.status === 'DEACTIVE' ? 'deactive-status' : ''"
                      [value]='key.districtId'
              >{{ key.name }}
              </option>
            </select>
          </div>
          <div class='col-6 mb-2 filter-cell'>
            <nb-form-field>
              <input nbInput fullWidth placeholder='Postcode' fieldSize='tiny' class='override-nbinput-height'
                     [(ngModel)]='this.postcode'
                     [typeahead]='filterPostcode$'
                     [ngModelOptions]='{standalone: true}'
                     [typeaheadAsync]='true'
                     (typeaheadOnSelect)='selectPostcode($event)'
                     typeaheadOptionField='code'
                     typeaheadMinLength='3'
                     typeaheadWaitMs='1000'>
            </nb-form-field>
          </div>
          <div class='col-3 mb-2 filter-cell'>
            <select class='select-custom full-width-select' size='tiny'
                    [(ngModel)]='sortType' (change)='onSortTypeSelectChange()'>
              <option *ngFor='let item of sortTypesText | keyvalue:keepOrder'
                      [ngValue]='item.key'
              >{{ item.value }}
              </option>
            </select>
          </div>
          <div class='col-3 mb-2 filter-cell'>
            <select class='select-custom full-width-select' size='tiny' [(ngModel)]='searchRequest.rate' (change)='onRateSelectChange()'>
              <option class='select-option' [value]='undefined'>Rate</option>
              <option class='select-option' *ngFor='let item of rateOptions'
                      [value]='item.value'>{{ item.label }}
              </option>
            </select>
          </div>
          <div class='col-3 mb-2 filter-cell'>
            <select class='select-custom full-width-select motive-select' size='tiny' [(ngModel)]='searchRequest.motivateNumber'
                    (change)="onMotivateSelectChange()">
              <option class='select-option' [value]='undefined'>Motive</option>
              <option class='select-option' *ngFor='let item of rateOptions'
                      [value]='item.value'>{{ item.label }}
              </option>
            </select>
          </div>
          <div class='col-3 mb-2 filter-cell'>
            <input
              [(ngModel)]='categoryName'
              [ngModelOptions]='{standalone: true}'
              [typeahead]='filterCategory$'
              [typeaheadAsync]='true'
              (typeaheadOnSelect)='selectCategory($event)'
              typeaheadOptionField='name'
              typeaheadWaitMs='1000'
              placeholder='Tag'
              nbInput
              fieldSize='tiny'
              fullWidth>
          </div>
          <div class='col-lg-3 col-md-6 col-12 mb-2 filter-cell filter-info-cell'>
            <div class='total-records-value'>Total Prospect: {{ totalRecords }}</div>
          </div>
          <div class='col-lg-3 col-md-6 col-12 mb-2 filter-cell filter-info-cell'>
            <div class='commission-value'>
              Commission: ${{ commission | number:'1.0-2' }}
            </div>
          </div>
          <div class='col-lg-3 d-none d-lg-block mb-2 filter-cell'></div>
          <div class='col-lg-3 d-none d-lg-block mb-2 filter-cell'></div>
<!--          <div class='w-20'>-->
<!--            <nb-form-field>-->
<!--              <input [nbDatepicker]='fromDate' nbInput fieldSize='tiny'-->
<!--                     fullWidth [(ngModel)]='fromPurchaseDate' placeholder='From Purchase Date' />-->
<!--              <nb-datepicker #fromDate></nb-datepicker>-->
<!--            </nb-form-field>-->
<!--          </div>-->
<!--          <div class='w-20'>-->
<!--            <nb-form-field>-->
<!--              <input [nbDatepicker]='toDate' nbInput fieldSize='tiny'-->
<!--                     fullWidth [(ngModel)]='toPurchaseDate' placeholder='To Purchase Date' />-->
<!--              <nb-datepicker #toDate></nb-datepicker>-->
<!--            </nb-form-field>-->
<!--          </div>-->
<!--          <div class='w-100'>-->
<!--            <div class='w-20 float-right'>-->
<!--              <nb-form-field>-->
<!--                <input nbInput fieldSize='tiny'-->
<!--                       fullWidth-->
<!--                       [(ngModel)]='toSellPrice'-->
<!--                       placeholder='To Price'-->
<!--                       type= 'text'-->
<!--                       (keydown)="allowOnlyNumbers($event)"-->
<!--                />-->
<!--              </nb-form-field>-->
<!--            </div>-->
<!--            <div class='w-20 float-right'>-->
<!--              <nb-form-field>-->
<!--                <input nbInput fieldSize='tiny'-->
<!--                       fullWidth-->
<!--                       [(ngModel)]='fromSellPrice'-->
<!--                       placeholder='From Price'-->
<!--                       type= 'text'-->
<!--                       (keydown)="allowOnlyNumbers($event)"-->
<!--                />-->
<!--              </nb-form-field>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class='w-100'>-->
<!--            <div class='w-20 float-right'>-->
<!--              <nb-form-field>-->
<!--                <input nbInput fieldSize='tiny'-->
<!--                       fullWidth-->
<!--                       [(ngModel)]='toAge'-->
<!--                       placeholder='To Age'-->
<!--                       type= 'text'-->
<!--                       (keydown)="allowOnlyNumbers($event)"-->
<!--                />-->
<!--              </nb-form-field>-->
<!--            </div>-->
<!--            <div class='w-20 float-right'>-->
<!--              <nb-form-field>-->
<!--                <input nbInput fieldSize='tiny'-->
<!--                       fullWidth-->
<!--                       [(ngModel)]='fromAge'-->
<!--                       placeholder='From Age'-->
<!--                       type= 'text'-->
<!--                       (keydown)="allowOnlyNumbers($event)"-->
<!--                />-->
<!--              </nb-form-field>-->
<!--            </div>-->
<!--          </div>-->
          <div class='col-lg-3 col-md-6 col-12 offset-md-6 offset-lg-9 mb-2 filter-cell tag-list-container' *ngIf='selectedCategories.length > 0'>
            <div class='category-block' *ngFor='let category of selectedCategories'>
              <button class='btn btn-danger btn-sm ml-1' (click)='removeCategory(category)'>
                <i class='fa fa-times' aria-hidden='true'></i>
              </button>
              {{ category.name }}
            </div>
          </div>
          <div class="col-12 mt-2 p-0 text-end">
            <button *ngIf="prospectIdCheckedList.length > 1" class='mr-1 mt-0 custom-client-list-button-color' nbButton size='tiny' (click)='onApplyAll()'><i
              class='fa mr-1 fa-pull-right'></i> Apply All
            </button>
            <button *ngIf="applyAll" class='mr-1 mt-0 custom-client-list-button-color' nbButton size='tiny' (click)='cancelApplyAll()'><i
              class='fa mr-1 fa-pull-right'></i> Cancel
            </button>
          </div>
        </div>


        <!--        END FILTER-->
        <div class='text-center mt-5 mb-4' *ngIf='!displayList'>
          Please enter address
        </div>
        <div class='text-center mt-5 mb-4' *ngIf='displayList && wrapItems.length === 0'>
          We can not find any address match your criteria
        </div>
        <div *ngIf='displayList && wrapItems.length > 0'>
          <table class='table freeze mt-2'>
            <tr>
              <th class='border-top-0 w-6'>
                <nb-checkbox id='all' [(ngModel)]='allChecked' [ngModelOptions]=' {standalone: true}'
                             (checkedChange)='checkAll($event)'></nb-checkbox>
              </th>
              <th class='border-top-0'>
                <div class='row m-0'>
                  <button *ngIf='prospectIdCheckedList.length > 0' nbButton size='tiny' hero class='custom-client-list-button-color ml-2'
                          (click)='clearAllSelected()'>Clear All Selected
                  </button>
                  <div *appPermissionCheck='ComponentPermission.CLIENT_DELETE'>
                    <button nbButton class='ml-2 custom-client-list-delete-button' size='tiny' hero
                            *ngIf='prospectIdCheckedList.length > 0'
                            (click)='removeSelected()'>Remove Selected
                    </button>
                  </div>
                </div>
              </th>
            </tr>
            <tr *ngFor='let wrapItem of wrapItems, let index = index'>
              <td colspan="2" class="p-0">
                <table class="table m-0" [ngClass]='{"is-expanding" : wrapItem?.isExpanded}'>
                  <!-- display parent row -->
                  <tr class="row-prospect"
                      [ngClass]='{"expand-unit" : wrapItem?.isGrouped}'
                      [class]="WrapperUtils.highlightProspectRow(wrapItem)">
                    <td class='w-6'>
                      <nb-checkbox id='{{wrapItem?.data.prospectId}}' [(ngModel)]='wrapItem.isSelected'
                                   (checkedChange)='onCheck($event, wrapItem.data)'
                                  ></nb-checkbox>
                    </td>
                    <td (click)='selectRow(wrapItem)' class='pointer'>
                      <div class='row prospect-summary-row'>
                        <div class='col-8 prospect-summary-main'>
                          <div class='col-12 mb-1'>
                            <div class='font-weight-bold name-line text-overflow-ellipsis'
                                 [ngClass]='stringUtils.getFullName(wrapItem?.data) === " " ? "blank-space" : ""'>
                              {{ stringUtils.getFullName(wrapItem?.data) }}<span *ngIf='stringUtils.getAllTags(wrapItem?.data?.categories)'>
                                ({{ stringUtils.getAllTags(wrapItem?.data?.categories) }})
                              </span>
                            </div>
                          </div>
                          <div class='col-12'>
                            <div
                              class='address-line text-overflow-ellipsis'>{{ stringUtils.getShortAddress(wrapItem?.data.address) }}
                            </div>
                          </div>
                        </div>
                        <div class='col-4 text-right prospect-summary-side' *ngIf="wrapItem?.data.totalUnit === 1 || wrapItem?.data.totalUnit === null">
                          <div class='col-12 mb-1'>
                            <div
                              class='font-weight-bold classification-line'
                              [ngStyle]="{'color': stringUtils.getClassification(wrapItem?.data)?.includes('3') ? '#b22222' : null}">{{ stringUtils.getClassification(wrapItem?.data) }}
                            </div>
                          </div>
                          <div class='col-12'>
                            <div class='spec-line'>
                              {{ stringUtils.getSpec(wrapItem?.data) }}
                            </div>
                          </div>
                        </div>
                        <div class='col-4 text-right prospect-summary-side' *ngIf="wrapItem?.data.totalUnit > 1">
                          <div class='col-12 mb-1'>
                            <div class='font-weight-bold classification-line'>
                              {{ wrapItem?.data.totalUnit }} (units)
                            </div>
                          </div>
                          <div class='col-12'>
                            <div class='spec-line'>
                              <nb-icon class='ml-2' [icon]="'expand-outline'" pack='eva'></nb-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <!-- display childs -->
                  <tr *ngFor='let subWrapItem of wrapItem.childs, let index = index'
                      class="row-prospect"
                      [ngClass]='subWrapItem?.isGrouped ? "expand-unit" : ""'
                      [class]="WrapperUtils.highlightProspectRow(subWrapItem)">
                    <td class='w-6'>
                      <nb-checkbox id='{{subWrapItem?.data.prospectId}}' [(ngModel)]='subWrapItem.isSelected'
                                   (checkedChange)='onCheck($event, subWrapItem)'></nb-checkbox>
                    </td>
                    <td (click)='selectRow(subWrapItem)'
                        class='pointer'>
                      <div class='row prospect-summary-row'>
                        <div class='col-8 prospect-summary-main'>
                          <div class='col-12 mb-1'>
                            <div class='font-weight-bold name-line text-overflow-ellipsis'
                                 [ngClass]='stringUtils.getFullName(subWrapItem?.data) === " " ? "blank-space" : ""'>
                              {{ stringUtils.getFullName(subWrapItem?.data) }}<span *ngIf='stringUtils.getAllTags(subWrapItem?.data?.categories)'>
                                ({{ stringUtils.getAllTags(subWrapItem?.data?.categories) }})
                              </span>
                            </div>
                          </div>
                          <div class='col-12'>
                            <div
                              class='address-line text-overflow-ellipsis'>{{ stringUtils.getShortAddress(subWrapItem?.data.address) }}
                            </div>
                          </div>
                        </div>
                        <div class='col-4 text-right prospect-summary-side'>
                          <div class='col-12 mb-1'>
                            <div
                              class='font-weight-bold classification-line'
                              [ngStyle]="{'color': stringUtils.getClassification(subWrapItem?.data)?.includes('3') ? '#b22222' : null}">{{ stringUtils.getClassification(subWrapItem?.data) }}
                            </div>
                          </div>
                          <div class='col-12'>
                            <div class='spec-line'>{{ stringUtils.getSpec(subWrapItem?.data) }}</div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <div class='mt-3'>
            <nav>
              <ul class='pagination justify-content-center'>
                <li class='page-item pointer' [ngClass]='this.currentPage === 1 ? "disabled" : ""'>
                  <span class='page-link' (click)= 'loadPage(null, false)' >Previous</span>
                </li>

                <li class='page-item pointer' *ngFor='let page of pages'
                    [ngClass]='this.currentPage === page ? "active" : ""'>
                  <span class='page-link' (click)='loadPage(page, null)'>{{ page }}</span>
                </li>
                <li class='page-item pointer' [ngClass]='this.currentPage === this.totalPages ? "disabled" : ""'>
                  <span class='page-link' (click)='loadPage(null, true)'>Next</span>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer class='p-0 mt-2 mb-2 border-top-0'>
        <div class='row m-0 text-center' *ngIf='displayList'>
          <div *ngFor='let button of prospectTagButtons' class='col p-0 d-flex justify-content-center'>
            <button nbButton class='custom-button d-block p-0'
                    (click)='selectProspectTag(button)' [status]='button.selected === true ? "warning" : "basic"'
                    value='{{button.value}}'>
              <div><i class='fa fa-dollar'></i></div>
              <div>{{ button.key }}</div>
            </button>
          </div>
          <!--          <div class='col p-0 d-flex justify-content-center'>-->
          <!--            <button class='custom-button d-block p-0' nbButton>-->
          <!--              <div>1M</div>-->
          <!--              <div>Search</div>-->
          <!--            </button>-->
          <!--          </div>-->
        </div>
      </nb-card-footer>
    </nb-card>
  </div>
  <div class='col-md-5 pl-0 col-sm-12 right-panel table-right-container'
       [ngClass]="{
       'popup-detail': isDisplay,
       'hide-detail': !isDisplay
       }">
    <ngx-prospect-dialog-v2
      [(prospectIdCheckedList)]="prospectIdCheckedList"
      [(isApplyAll)]='applyAll'
      [closeAfterSave]='false'
      [companies]="companies"
      [selectedProspect]='selectedProspect'
      (navigateProspectEvent)='navigateProspect($event)'
      (editDone)='editDone($event)'
      (onCloseDialog)='cancel($event)'
      [isDetailSearch]='isDetailSearch'
      (detailSearchDone)="isDetailSearch"
      (detailSearchChange)='onSearchButtonClick($event)'
    >
    </ngx-prospect-dialog-v2>
    <!--      </nb-card-body>-->
    <!--    </nb-card>-->
  </div>
</div>
